import Divider from '../../../../../../../components/Divider';
import { LogoutOutlined } from '../../../../../../../components/Icon';
import * as paths from '../../../../../../Header/constants/paths';
import React from 'react';
import { useHijackUser } from './hooks';
import { CurrentUser, Menu } from './styled';
var OverlayMenu = function (_a) {
    var links = _a.links, handleLogout = _a.handleLogout, version = _a.version, items = _a.items, canHijackUser = _a.canHijackUser, profile = _a.profile, logoutUrl = _a.logoutUrl;
    var _b = useHijackUser(canHijackUser), captureMenuItem = _b.captureMenuItem, userSelectModal = _b.userSelectModal, capturingUser = _b.capturingUser;
    var currentUserName = (capturingUser === null || capturingUser === void 0 ? void 0 : capturingUser.name) || profile.name || profile.lastName + " " + profile.firstName;
    return (React.createElement(React.Fragment, null,
        React.createElement(Menu, { selectable: false },
            currentUserName && (React.createElement(React.Fragment, null,
                React.createElement(CurrentUser, { key: 'menu-current-user', disabled: true }, currentUserName),
                React.createElement(Divider, { style: { margin: 0 } }))), links === null || links === void 0 ? void 0 :
            links.map(function (_a) {
                var link = _a.link, text = _a.text, icon = _a.icon, onClick = _a.onClick;
                return (React.createElement(Menu.Item, { icon: icon, key: link, onClick: onClick },
                    React.createElement("a", { href: link }, text)));
            }), items === null || items === void 0 ? void 0 :
            items.map(function (_a) {
                var id = _a.id, icon = _a.icon, content = _a.content, onClick = _a.onClick, className = _a.className;
                return (React.createElement(Menu.Item, { icon: icon, key: id, onClick: onClick, className: className },
                    React.createElement(React.Fragment, null, content)));
            }),
            canHijackUser && captureMenuItem,
            React.createElement(Menu.Item, { key: 'menu-logout', icon: React.createElement(LogoutOutlined, null), onClick: handleLogout },
                React.createElement("a", { href: logoutUrl || paths.LOGOUT }, "\u0412\u044B\u0445\u043E\u0434")),
            React.createElement(Menu.Item, { key: 'menu-version', disabled: true }, version)),
        canHijackUser && userSelectModal));
};
export default OverlayMenu;
//# sourceMappingURL=OverlayMenu.js.map